export default {
    name: "DownloadFile",
    title: "Download File",
    icon: "mdi-cloud-download-outline",
    create() {
        return {
            name: this.name,
            description: null,
            actionType: this.name,
            url: null
        };
    },
};